import { FunnelIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useState } from 'react';
import { useTaxonomyContext } from '../../../contexts/Taxonomy';
import { GbFilter } from '../../icons';
import ActiveFilters from './ActiveFilters';
import FilterOptions from './FilterOptions';
import Modal from './Modal';
import ResultCount from './ResultCount';
import SortByOptions from './SortByOptions';
import TSTaxonomy from '../../../utils/typesense/taxonomy';
import { IFilterOptionData } from '../../../utils/types/taxonomy';
import {
    ITSFilterOption,
    ITSTaxonomyFilterOptions,
} from '../../../utils/typesense/types/taxonomy';

export default function Filter(props: {
    pageNo: number;
    productCount: number;
    applyFilter: any;
    onSortChange: any;
    taxonomyFilterOptions: ITSTaxonomyFilterOptions;
    priceFilter: ITSFilterOption;
}) {
    const {
        pageNo,
        productCount,
        applyFilter,
        onSortChange,
        taxonomyFilterOptions,
        priceFilter,
    } = props;
    const taxonomyCtx = useTaxonomyContext();

    const [filterOpen, setFilterOpen] = taxonomyCtx.slideOverFilter;
    const [sortByOpen, setSortByOpen] = taxonomyCtx.slideOverSort;

    const [selectedSortOption] = taxonomyCtx.sortByState;

    const handleFilterByClicked = () => {
        setFilterOpen(!filterOpen);
    };

    const handleSortByClicked = () => {
        setSortByOpen(!sortByOpen);
    };

    const applyFilterClicked = () => {
        setFilterOpen(false);
        applyFilter();
    };

    const resetFilterAction = (e: any) => {
        const [, , , setPrice] = taxonomyCtx.priceFilter;
        setPrice(null);

        const [, , , setType] = taxonomyCtx.typeFilter;
        setType(null);

        const [, , , setOcassion] = taxonomyCtx.ocassionFilter;
        setOcassion(null);

        const [, , , setSuitableFor] = taxonomyCtx.suitableForFilter;
        setSuitableFor(null);
    };

    return (
        <>
            <Modal open={filterOpen} setOpen={setFilterOpen} name="FILTER BY:">
                <FilterOptions
                    name={priceFilter.label}
                    options={priceFilter.items}
                    disclosureProp={taxonomyCtx.priceFilter}
                />
                <FilterOptions
                    name={taxonomyFilterOptions.types.label}
                    options={taxonomyFilterOptions.types.items}
                    disclosureProp={taxonomyCtx.typeFilter}
                />
                <FilterOptions
                    name={taxonomyFilterOptions.favourites.label}
                    options={taxonomyFilterOptions.favourites.items}
                    disclosureProp={taxonomyCtx.favouriteFilter}
                />
                <FilterOptions
                    name={taxonomyFilterOptions.occasions.label}
                    options={taxonomyFilterOptions.occasions.items}
                    disclosureProp={taxonomyCtx.ocassionFilter}
                />
                <FilterOptions
                    name={taxonomyFilterOptions.suitableFor.label}
                    options={taxonomyFilterOptions.suitableFor.items}
                    disclosureProp={taxonomyCtx.suitableForFilter}
                />

                <button
                    className="hidden mt-3 w-full border border-black mb-2 p-2.5"
                    onClick={applyFilterClicked}
                >
                    APPLY
                </button>
                <button
                    onClick={resetFilterAction}
                    className="w-full border border-black mb-2 p-2.5"
                >
                    RESET
                </button>
            </Modal>
            <Modal open={sortByOpen} setOpen={setSortByOpen} name="SORT BY:">
                <SortByOptions
                    state={taxonomyCtx.sortByState}
                    options={TSTaxonomy.sortOptions}
                    onSortChange={onSortChange}
                />
            </Modal>

            <div className=" flex xl:hidden sticky top-0 z-10 bg-[#FAFAF6]">
                <button
                    onClick={handleFilterByClicked}
                    className="flex flex-1 uppercase border border-brand-second-gray py-3 text-xs leading-6 text-black flexss justify-center items-center gap-3 border-r-0 "
                >
                    Filter By:{' '}
                    <FunnelIcon className="text-black h-5 group-hover:text-white" />
                </button>
                <button
                    onClick={handleSortByClicked}
                    className="flex-1 uppercase border border-brand-second-gray py-3 text-xs leading-6 text-black"
                >
                    Sort By:
                </button>
            </div>

            <div className="1 hidden xl:flex xl:justify-between flex-1 gap-5 pt-5">
                <div className="flex-1 flex gap-4.5 items-center">
                    <button
                        onClick={handleFilterByClicked}
                        className=" flex group flex-1 uppercase border border-brand-second-gray py-3 text-xs leading-6 text-black flexsss justify-center items-center gap-3 max-w-[187px] hover:text-white hover:bg-brand-secondary-dark"
                    >
                        Filter By:{' '}
                        <FunnelIcon className="text-black h-5 group-hover:text-white" />
                    </button>

                    <ActiveFilters applyFilter={applyFilter} />
                </div>

                <button
                    onClick={() => {
                        setSortByOpen((prev) => !prev);
                    }}
                    className="flex group flex-1 border border-brand-second-gray py-3 text-xs leading-6 text-black flexsss justify-center items-center gap-3 max-w-[187px] hover:text-white hover:bg-brand-secondary-dark"
                >
                    SORT: {selectedSortOption.label}
                </button>
            </div>

            <div className="xl:flex xl:items-center xl:gap-8 mt-2 space-y-2">
                <ResultCount pageNo={pageNo} productCount={productCount} />
                <div className="block xl:hidden">
                    <ActiveFilters applyFilter={applyFilter} />
                </div>
            </div>
        </>
    );
}
